module.exports = __webpack_public_path__ + "img/单脚测量扫描仪.7e2d2100.png";